// import $ from 'jquery';
import React from 'react';
import Field from 'components/fields/Field';
import { isCreditCard } from 'validator';
// import PropTypes from 'prop-types';

// OPTIMIZE: Display card flag

class FieldCreditCard extends Field {
    constructor(props) {
        super(props);
    }
    // format(value) {
    // }
    validate() {
        const { value } = this.props;
        return super.validate() && isCreditCard(value);
    }
    // render() {
    //     return(
    //         <span>Test</span>
    //     );
    // }
}

export default FieldCreditCard;
